// extracted by mini-css-extract-plugin
export var common = "Report-module--common--3y4vd";
export var calculateButton = "Report-module--calculateButton--1xb3B";
export var container = "Report-module--container--iHWlC";
export var logo = "Report-module--logo--16KaJ";
export var heading = "Report-module--heading--T2jlh";
export var graph = "Report-module--graph--n8_6J";
export var directions = "Report-module--directions--2O_kA";
export var fadeIn = "Report-module--fadeIn--pVzPS";
export var moveLeft = "Report-module--moveLeft--3SF36";
export var moveDown = "Report-module--moveDown--3l68d";
export var illuMoveDown = "Report-module--illuMoveDown--2v_6U";